import { Badge, BadgeWithDot } from "@/components/ui/badge"

const KIND_LABELS: Record<string, string> = {
  resource_link: "Resource link",
  online_service: "Online service",
  helpline: "Helpline",
}

type StatusColor = "gray" | "success" | "warning"

const STATUS_COLORS: Record<string, StatusColor> = {
  draft: "gray",
  validated: "success",
  archived: "warning",
}

export function DestinationKindBadge({ kind }: { kind: string }) {
  return (
    <Badge color="gray" size="sm" type="pill-color">
      {KIND_LABELS[kind] ?? kind}
    </Badge>
  )
}

export function DestinationStatusBadge({ status }: { status: string }) {
  return (
    <BadgeWithDot
      color={STATUS_COLORS[status] ?? "gray"}
      size="sm"
      type="modern"
      className="capitalize"
    >
      {status}
    </BadgeWithDot>
  )
}
